export const TOGGLE_INITIAL_MESSAGE_BUBBLE = 'TOGGLE_INITIAL_MESSAGE_BUBBLE';